import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import ErrorMessage from "../../../common/js/components/ErrorMessage";
import AccountingVouchersContainer from "./AccountingVouchersContainer";

const VouchersContainer = (props) => {
    const { userProfile } = props;
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/vouchers", title: "Vouchers" });
    }, []);
    return ["accounting"].includes(userProfile?.role) ? <AccountingVouchersContainer {...props} /> : <ErrorMessage />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
    };
};

export default connect(mapStateToProps)(VouchersContainer);
